import { TextField } from "@mui/material";
import { ButtonAdd } from "components/buttons";
import { MprcFilterLine } from "components/filter";
import { MprcFilterBox } from "components/filter/MprcFilterBox";
import { IconButtonBlocked } from "components/iconButtons";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ICustomQuickFilterOptions {
    searchText: string;
    listExpired: boolean | null;
}

interface IProps {
    filterOptions: ICustomQuickFilterOptions;
    onAdd: () => void;
    onFilterChange: (filter: ICustomQuickFilterOptions, forceLoad: boolean) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const Filter: React.FC<IProps> = ({ filterOptions, onAdd, onFilterChange }) => {
    ////////////////////////////////////////////////////////////////////////////////

    const { t } = useTranslation("knowledge");

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcFilterBox>
            <MprcFilterLine>
                <div>
                    <ButtonAdd size="large" text={t("QuickFilter.List.AddButtonText")} onClick={onAdd} color="inherit" />
                </div>
                <div>
                    <IconButtonBlocked
                        title={t("shared:Actions.ListInactive")}
                        color={filterOptions.listExpired ? "warning" : "inherit"}
                        onClick={() => onFilterChange({ ...filterOptions, listExpired: !filterOptions.listExpired }, true)}
                    />
                </div>
            </MprcFilterLine>
            <TextField
                fullWidth
                placeholder={t("QuickFilter.List.SearchTextPlaceholder")}
                value={filterOptions.searchText}
                onKeyDown={(e) => e.keyCode == 13 && onFilterChange(filterOptions, true)}
                onChange={(e) => onFilterChange({ ...filterOptions, searchText: e.target.value }, false)}
            />
        </MprcFilterBox>
    );
};
